import { FC, ReactChild, useState, useCallback, useEffect } from 'react'
import styles from 'components/features/coaching/advisorVideoCall/VideoCallPagePreset/VideoCallPagePreset.styl'
import CommonFooter from 'components/molecules/CommonFooter'
import cn from 'classnames'
import { cssVar } from 'helpers/styleHelpers'

type VideoCallPagePresetProps = {
  isFullScreen: boolean
  header?: ReactChild | null
  bottomCta?: ReactChild | null
  controls?: ReactChild | null
}
export const VideoCallPagePreset: FC<VideoCallPagePresetProps> = (props) => {
  const { children, controls, header, bottomCta, isFullScreen } = props

  const [isControlsVisible, setIsControlsVisible] = useState(false)

  const handleContentClick = useCallback(() => {
    setIsControlsVisible((state) => !state)
  }, [])

  const [innerHeight, setInnerHeight] = useState(window.innerHeight)
  useEffect(() => {
    const handle = () => {
      setInnerHeight((prevState) => {
        if (prevState === window.innerHeight) {
          return prevState
        }
        return window.innerHeight
      })
    }

    window.addEventListener('resize', handle)
    return () => {
      window.removeEventListener('resize', handle)
    }
  }, [])

  return (
    <div
      className={ cn(styles.videoCallPagePreset, isFullScreen && styles.fullScreen, isControlsVisible && styles.controlsVisible) }
      style={ cssVar({
        '--innerHeight': `${ innerHeight }px`,
      }) }
    >
      { header }
      { children && (
        <div className={ styles.content } onClick={ handleContentClick }>
          { children }
        </div>
      )}
      { controls && (
        <div className={ styles.controls }>
          { controls }
        </div>
      )}
      { bottomCta && (
        <div className={ styles.bottomCta }>
          { bottomCta }
        </div>
      )}
      <div className={ styles.spacer } />
      <CommonFooter className={ styles.footer } />
    </div>
  )
}
